import { BookOpen, Pencil, Calculator, Globe, Microscope, GraduationCap, Baby, Users, Atom, Triangle, BarChart3, TrendingUp, PieChart } from 'lucide-react';

export const educationLevels = [
  {
    id: 'pre_k',
    label: 'Pre-K',
    icon: Baby,
    color: '#FEF3C7',
    selectedColor: '#F59E0B',
    borderColor: '#FCD34D'
  },
  {
    id: 'kindergarten',
    label: 'Kindergarten',
    icon: BookOpen,
    color: '#FCE7F3',
    selectedColor: '#EC4899',
    borderColor: '#F9A8D4'
  },
  {
    id: 'first_grade',
    label: 'Grade - 1',
    icon: Pencil,
    color: '#DBEAFE',
    selectedColor: '#3B82F6',
    borderColor: '#93C5FD'
  },
  {
    id: 'second_grade',
    label: 'Grade - 2',
    icon: BookOpen,
    color: '#D1FAE5',
    selectedColor: '#10B981',
    borderColor: '#6EE7B7'
  },
  {
    id: 'third_grade',
    label: 'Grade - 3',
    icon: Calculator,
    color: '#E9D5FF',
    selectedColor: '#8B5CF6',
    borderColor: '#C4B5FD'
  },
  {
    id: 'fourth_grade',
    label: 'Grade - 4',
    icon: Globe,
    color: '#FED7AA',
    selectedColor: '#F97316',
    borderColor: '#FDBA74'
  },
  {
    id: 'fifth_grade',
    label: 'Grade - 5',
    icon: Microscope,
    color: '#FECACA',
    selectedColor: '#EF4444',
    borderColor: '#FCA5A5'
  },
  {
    id: 'sixth_grade',
    label: 'Grade - 6',
    icon: Users,
    color: '#CCFBF1',
    selectedColor: '#14B8A6',
    borderColor: '#5EEAD4'
  },
  {
    id: 'seventh_grade',
    label: 'Grade - 7',
    icon: Atom,
    color: '#C7D2FE',
    selectedColor: '#6366F1',
    borderColor: '#A5B4FC'
  },
  {
    id: 'eighth_grade',
    label: 'Grade - 8',
    icon: BookOpen,
    color: '#CFFAFE',
    selectedColor: '#06B6D4',
    borderColor: '#67E8F9'
  },
  {
    id: 'ninth_grade',
    label: 'Grade - 9',
    icon: BookOpen,
    color: '#E0E7FF',
    selectedColor: '#4F46E5',
    borderColor: '#A5B4FC'
  },
  {
    id: 'tenth_grade',
    label: 'Grade - 10',
    icon: BookOpen,
    color: '#F3E8FF',
    selectedColor: '#9333EA',
    borderColor: '#D8B4FE'
  },
  {
    id: 'eleventh_grade',
    label: 'Grade - 11',
    icon: BookOpen,
    color: '#FFEDD5',
    selectedColor: '#EA580C',
    borderColor: '#FDBA74'
  },
  {
    id: 'twelfth_grade',
    label: 'Grade - 12',
    icon: GraduationCap,
    color: '#DCFCE7',
    selectedColor: '#16A34A',
    borderColor: '#86EFAC'
  },
  {
    id: 'algebra_1',
    label: 'Algebra 1',
    icon: BarChart3,
    color: '#D1F2EB',
    selectedColor: '#059669',
    borderColor: '#6EE7B7'
  },
  {
    id: 'geometry',
    label: 'Geometry',
    icon: Triangle,
    color: '#DDD6FE',
    selectedColor: '#7C3AED',
    borderColor: '#C4B5FD'
  },
  {
    id: 'algebra_2',
    label: 'Algebra 2',
    icon: TrendingUp,
    color: '#FCE7F3',
    selectedColor: '#E11D48',
    borderColor: '#F9A8D4'
  },
  {
    id: 'precalculus',
    label: 'Precalculus',
    icon: PieChart,
    color: '#FEF3C7',
    selectedColor: '#D97706',
    borderColor: '#FCD34D'
  }
];
